import { apiSlice } from './apiSlice';

/**
 * Analyst agreements, one per funded account.
 *
 *   GET /v3/get/contract/user-list/ → { is_verified, data: [{ id, login_id,
 *                                       user_email, document_id, document_link,
 *                                       created_at, updated_at, issued, status,
 *                                       risk, challenge_name, is_verified }] }
 *
 * The top-level `is_verified` is true once every contract is signed; each row
 * carries its own. `status` is DigiSigner's ("In Progress", …) and
 * `document_link` is where the trader signs — there is no signing endpoint.
 */
export const contractsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContracts: builder.query({
      query: () => '/v3/get/contract/user-list/',
    }),
  }),
});

export const { useGetContractsQuery } = contractsApi;
